import type { FilterOption } from '@/scopes/search/types'
import { useIntl } from '@/intl'
import * as DurationFilterPrimitive from '@/scopes/common/components/Filters/DurationFilterPrimitive'
import { Filter } from '@/scopes/search/components/QuickSearchBar/Filter'
import { FilterSummary } from '@/scopes/search/components/QuickSearchBar/FilterSummary'
import { useQuickSearchStore } from '@/scopes/search/components/QuickSearchBar/store'
import { useMultiSelectFilter } from '@/scopes/search/search/domain/hooks'
import { Button } from '@sunwebgroup/ui-components/uds'
import * as React from 'react'

export function DurationFilterComponent({
  disabled,
  onConfirm,
  options,
  selectedOptions,
  id,
  asSheet,
  biggerBreakpoint,
  ...rest
}: {
  disabled?: boolean
  onConfirm: (selection: string[]) => void
  options: FilterOption<string>[]
  selectedOptions: FilterOption<string>[]
  id: string
  asSheet?: boolean
  biggerBreakpoint?: boolean
}) {
  const intl = useIntl()
  const { setActiveItem } = useQuickSearchStore()
  const [localSelectedValues, setLocalSelectedValues] = React.useState(selectedOptions.map(option => option.value))
  const onSelectedValueChange2 = (newSelectedValue: string[]) => {
    setLocalSelectedValues(newSelectedValue)
  }

  React.useEffect(() => {
    setLocalSelectedValues(selectedOptions.map(option => option.value))
  }, [selectedOptions])

  const handleConfirm = () => {
    setActiveItem(null)
    onConfirm(localSelectedValues)
  }

  return (
    <Filter
      id={id}
      placeholder={intl.formatMessage({
        id: 'quicksearch_filter_travel_duration_placeholder',
      })}
      title={intl.formatMessage({
        id: 'quicksearch_filter_travel_duration_title',
      })}
      onConfirm={handleConfirm}
      selectionFormattedText={getFormattedSelectedValues(selectedOptions)}
      asSheet={asSheet}
      hasPadding={false}
      biggerBreakpoint={biggerBreakpoint}
      data-qa="duration-filter"
      autoFocus
      {...rest}
    >
      <DurationFilterPrimitive.Root
        options={options}
        selectedValues={localSelectedValues}
        onSelectedValueChange={onSelectedValueChange2}
      />
      <DurationFilterPrimitive.Footer>
        <Button onClick={handleConfirm} disabled={disabled} fullWidth>
          {intl.formatMessage({ id: 'quicksearch_save_button_text' })}
        </Button>
      </DurationFilterPrimitive.Footer>
    </Filter>
  )
}

export function DurationFilterSummary() {
  const { selectedOptions } = useMultiSelectFilter('Duration')
  const formattedText = {
    long: getFormattedSelectedValues(selectedOptions) ?? '',
  }
  return <FilterSummary icon="Duration" texts={formattedText} />
}

function getFormattedSelectedValues(selectedOptions: FilterOption<string>[]) {
  return selectedOptions.length > 0
    ? selectedOptions.map(option => option.name).join(', ')
    : undefined
}
